import {
    Mail,
    Phone,
    MapPin,
    Instagram,
    MessageCircleMore,
    Facebook,
} from "lucide-react";

import logo from "/logo.webp";
import logoB from "/logoB.webp";

const navitems = [
    {
        label: "Home",
        bgColor: "#0d1821",
        textColor: "#f5f5f5",
        links: [
            {
                label: "Home",
                href: "/#hero",
                ariaLabel: "Home",
            },
        ],
    },
    {
        label: "Services",
        bgColor: "#170D27",
        textColor: "#f5f5f5",
        links: [
            {
                label: "Brand Growth Solution",
                href: "/brandgrowthsolution",
                ariaLabel: "Brand Growth Solution",
            },
            {
                label: "Smart Tech Solution",
                href: "/smarttechsolution",
                ariaLabel: "Smart Tech Solution",
            },
            {
                label: "WhatsApp & SMS Marketing",
                href: "/whatsappsmsmarketing",
                ariaLabel: "WhatsApp & SMS Marketing",
            },
        ],
    },
    {
        label: "Our Works",
        bgColor: "#271E37",
        textColor: "#f5f5f5",
        links: [
            {
                label: "Gallery",
                href: "/#works",
                ariaLabel: "Gallery",
            },
        ],
    },
    {
        label: "About Us",
        bgColor: "#271E37",
        textColor: "#f5f5f5",
        links: [
            {
                label: "What We Do",
                href: "/#whatwedo",
                ariaLabel: "What We Do",
            },
            {
                label: "Get a Estimate",
                href: "?form=estimate",
                ariaLabel: "Get a Estimate",
            },
        ],
    },
    {
        label: "Contact",
        bgColor: "#271E37",
        textColor: "#f5f5f5",
        links: [
            {
                label: "Email",
                href: "mailto:contact@company.com",
                ariaLabel: "Email us",
            },
            {
                label: "Twitter",
                href: "https://twitter.com/company",
                ariaLabel: "Twitter",
            },
            {
                label: "LinkedIn",
                href: "https://linkedin.com/company",
                ariaLabel: "LinkedIn",
            },
        ],
    },
];

const words = [
    { text: "Social Media Management." },
    { text: "Whatsapp & SMS Marketing." },
    { text: "Film Production & Photography." },
    { text: "Graphic Design & Illustration." },
    { text: "Website & App Development." },
    { text: "Social Media Management." },
    { text: "Whatsapp & SMS Marketing." },
    { text: "Film Production & Photography." },
    { text: "Graphic Design & Illustration." },
    { text: "Website & App Development." },
]


const imageLogos = [
    {
        src: "/images/logos/company-logo-1.png",
        alt: "Company 1",
        href: "https://company1.com",
    },
    {
        src: "/images/logos/company-logo-2.png",
        alt: "Company 2",
        href: "https://company2.com",
    },
    {
        src: "/images/logos/company-logo-3.png",
        alt: "Company 3",
        href: "https://company3.com",
    },
    {
        src: "/images/logos/company-logo-4.png",
        alt: "Company 1",
        href: "https://company1.com",
    },
    {
        src: "/images/logos/company-logo-5.png",
        alt: "Company 2",
        href: "https://company2.com",
    },
    {
        src: "/images/logos/company-logo-6.png",
        alt: "Company 3",
        href: "https://company3.com",
    },
    {
        src: "/images/logos/company-logo-7.png",
        alt: "Company 1",
        href: "https://company1.com",
    },
    {
        src: "/images/logos/company-logo-8.png",
        alt: "Company 2",
        href: "https://company2.com",
    },
    {
        src: "/images/logos/company-logo-9.png",
        alt: "Company 3",
        href: "https://company3.com",
    },
    {
        src: "/images/logos/company-logo-10.png",
        alt: "Company 1",
        href: "https://company1.com",
    },
    {
        src: "/images/logos/company-logo-11.png",
        alt: "Company 2",
        href: "https://company2.com",
    },
];

const socialLinks = [
    {
        icon: Instagram,
        href: "https://www.instagram.com/adszie.in/",
        label: "Instagram",
    },
    {
        icon: Facebook,
        href: "https://www.instagram.com/adszie.in/",
        label: "Facebook",
    },
];

const contactInfo = [
    { icon: Mail, text: "business@adszie.in", label: "Email", href: "mailto:business@adszie.in" },
    { icon: Phone, text: "+91 85849 59906", label: "Phone", href: "tel:+918584959906" },
    { icon: MessageCircleMore, text: "Adszie", label: "WhatsApp", href: "https://wa.link/rcwrap" },
    {
        icon: MapPin,
        text: "Girish Vidya Ratna Ln, Rajpur Sonarpur, Kolkata, West Bengal 700149",
        label: "Location",
        href: "https://maps.app.goo.gl/3SmxHkiphP2GLxqB9",
    },
];

const casestudy = [
    {
        id: 1,
        title: "Creative Design for Senco Gold & Diamonds",
        image1: "/images/gallery/p1a.jpg",
        image2: "/images/gallery/p1b.jpg",
    },
    {
        id: 3,
        title: "Creative Design for Burger King",
        image1: "/images/gallery/p3a.jpg",
        image2: "/images/gallery/p3b.jpg",
    },
    {
        id: 4,
        title: "Creative Design for Saboralia Confeitaria",
        image1: "/images/gallery/p4a.jpg",
        image2: "/images/gallery/p4b.jpg",
    },
    {
        id: 5,
        title: "Creative Design for Yuvora Jewels",
        image1: "/images/gallery/p5a.jpg",
        image2: "/images/gallery/p5b.jpg",
    },
    {
        id: 6,
        title: "Creative Design for Kavitha Gold & Diamonds",
        image1: "/images/gallery/p6a.jpg",
        image2: "/images/gallery/p6b.jpg",
    },
    {
        id: 7,
        title: "Creative Design for Yuvora Jewels",
        image1: "/images/gallery/p7a.jpg",
        image2: "/images/gallery/p7b.jpg",
    },
    {
        id: 8,
        title: "Creative Design for Saboralia Confeitaria",
        image1: "/images/gallery/p8a.jpg",
        image2: "/images/gallery/p8b.jpg",
    },
    {
        id: 9,
        title: "Creative Design for Rosie Confeitaria Artesanal",
        image1: "/images/gallery/p9a.jpg",
        image2: "/images/gallery/p9b.jpg",
    },
    {
        id: 10,
        title: "Creative Design for Budweiser and Redtape",
        image1: "/images/gallery/p10a.jpg",
        image2: "/images/gallery/p10b.jpg",
    },
];

const caseStudyModal = [{
    projectId: 1,
    title: "Creative Design for Senco Gold & Diamonds",
    images: ["/images/gallery/p1a.jpg", "/images/gallery/p1b.jpg",],
    url: "/brandgrowthsolution",
},
{
    projectId: 3,
    title: "Creative Design for Burger King",
    images: ["/images/gallery/p3a.jpg", "/images/gallery/p3b.jpg", "/images/gallery/p3c.jpg"],
    url: "/brandgrowthsolution",
},
{
    projectId: 4,
    title: "Creative Design for Saboralia Confeitaria",
    images: ["/images/gallery/p4a.jpg", "/images/gallery/p4b.jpg",],
    url: "/brandgrowthsolution",
},
{
    projectId: 5,
    title: "Creative Design for Yuvora Jewels",
    images: ["/images/gallery/p5a.jpg", "/images/gallery/p5b.jpg",],
    url: "/brandgrowthsolution",
},
{
    projectId: 6,
    title: "Creative Design for Kavitha Gold & Diamonds",
    images: ["/images/gallery/p6a.jpg", "/images/gallery/p6b.jpg",],
    url: "/brandgrowthsolution",
},
{
    projectId: 7,
    title: "Creative Design for Yuvora Jewels",
    images: ["/images/gallery/p7a.jpg", "/images/gallery/p7b.jpg",],
    url: "/brandgrowthsolution",
},
{
    projectId: 8,
    title: "Creative Design for Saboralia Confeitaria",
    images: ["/images/gallery/p8a.jpg", "/images/gallery/p8b.jpg", "/images/gallery/p8c.jpg"],
    url: "/brandgrowthsolution",
},
{
    projectId: 9,
    title: "Creative Design for Rosie Confeitaria Artesanal",
    images: ["/images/gallery/p9a.jpg", "/images/gallery/p9b.jpg", "/images/gallery/p9c.jpg"],
    url: "/brandgrowthsolution",
},
{
    projectId: 10,
    title: "Creative Design for Budweiser and Redtape",
    images: ["/images/gallery/p10a.jpg", "/images/gallery/p10b.jpg",],
    url: "/brandgrowthsolution",
},
{
    projectId: 21,
    title: "",
    images: ["/images/gallery/pwts1.jpg"],
    url: "/whatsappsmsmarketing",
},
{
    projectId: 22,
    title: "",
    images: ["/images/gallery/pwts2.jpg"],
    url: "/whatsappsmsmarketing",
},
{
    projectId: 31,
    title: "",
    images: ["/images/gallery/psts1.jpg"],
    url: "/smarttechsolution",
},
{
    projectId: 32,
    title: "",
    images: ["/images/gallery/psts2.jpg"],
    url: "/smarttechsolution",
},
]

const verticalCards = [
    {
        title: "Social Media Management",
        desc: "We create meaningful content strategies that go beyond likes and followers, focusing on real conversations and building strong communities.",
        href: "/brandgrowthsolution",
        bgColor: "#00a878",
        textColor: "#f5f5f5"
    },
    {
        title: "Logo Design",
        desc: "Memorable logo designs crafted to build strong and recognizable brands.",
        href: "/brandgrowthsolution",
        bgColor: "#c3f620",
        textColor: "#0d1821"
    },
    {
        title: "Brand Identity Design",
        desc: "Complete brand identity systems designed for consistency, recognition, and growth.",
        href: "/brandgrowthsolution",
        bgColor: "#00a878",
        textColor: "#f5f5f5"
    },
    {
        title: "Graphic Design & Illustrations",
        desc: "We design eye-catching visuals that reflect your brand and create engaging content for websites, apps, and online stores.",
        href: "/brandgrowthsolution",
        bgColor: "#c3f620",
        textColor: "#0d1821"
    },
    {
        title: "Video Editing, Animation & VFX",
        desc: "We create high-quality video edits, VFX, and 2D/3D animations designed for social media and digital platforms.",
        href: "/brandgrowthsolution",
        bgColor: "#00a878",
        textColor: "#f5f5f5"
    },
    {
        title: "Film Production & Photography",
        desc: "Our in-house team delivers end-to-end production—from scripts and shoots to ad films, product photos, reels, and long-form videos.",
        href: "/brandgrowthsolution",
        bgColor: "#c3f620",
        textColor: "#0d1821"
    },
    {

        title: "WhatsApp & SMS Marketing",
        desc: "We offer WhatsApp bulk messaging, SMS campaigns, and Meta Verified WhatsApp marketing to reach customers instantly with secure, reliable, and engaging communication.",
        href: "/whatsappsmsmarketing",
        bgColor: "#00a878",
        textColor: "#f5f5f5"
    },
    {
        title: "Custom Web Development",
        desc: "We build responsive websites with features like live chat, e-commerce, and community tools—helping your brand stand out online.",
        href: "/smarttechsolution",
        bgColor: "#c3f620",
        textColor: "#0d1821"
    },
    {
        title: "UI/UX Design",
        desc: "We design modern, user-friendly websites and apps backed by 500+ projects, using platforms like WordPress, Webflow, and ReactJS.",
        href: "/smarttechsolution",
        bgColor: "#00a878",
        textColor: "#f5f5f5"
    },

    {
        title: "Print, Outdoor & Traditional Ads",
        desc: "We create impactful offline assets like billboards, brochures, and business cards to strengthen your brand presence everywhere.",
        href: "/brandgrowthsolution",
        bgColor: "#c3f620",
        textColor: "#0d1821"
    },
];

const projectBGS = [
    {
        id: 1,
        title: "Creative Design for Senco Gold & Diamonds",
        image: "/images/gallery/p1a.jpg",
    },
    {
        id: 8,
        title: "Creative Design for Saboralia Confeitaria",
        image: "/images/gallery/p8c.jpg",
    },
    {
        id: 5,
        title: "Creative Design for Yuvora Jewels",
        image: "/images/gallery/p5a.jpg",
    },
    {
        id: 6,
        title: "Creative Design for Kavitha Gold & Diamonds",
        image: "/images/gallery/p6a.jpg",
    },
    {
        id: 9,
        title: "Creative Design for Rosie Confeitaria Artesanal",
        image: "/images/gallery/p9c.jpg",
    },]

const dropdownBGS = [
    {
        id: 1,
        title: "Social Media Management",
        content: "We don’t just focus on likes or followers. Instead, we create smart and practical content strategies that your audience will find useful. For us, social media is about building real conversations and strong communities.",
    },
    {
        id: 2,
        title: "Logo Design",
        content: "We create unique and strategically designed logos that represent your brand identity, values, and vision. Our logo design process focuses on building memorable visuals that improve brand recognition, create trust, and leave a strong impression across digital and print platforms.",
    },
    {
        id: 3,
        title: "Brand Identity Design",
        content: "We build complete brand identity systems that give your business a consistent and professional visual presence. From logo design, brand colors, typography, and guidelines to social media branding and visual direction, we create identities that help brands stand out and connect with their audience.",
    },
    {
        id: 4,
        title: "Content & Copywriting",
        content: "Our writers create clear, engaging, and meaningful content. From ads to blogs, we write with your customer’s intent in mind—making sure every word inspires clicks, shares, and action.",
    },
    {
        id: 5,
        title: "Graphic Design & Illustrations",
        content: "Visuals grab attention faster than words. Our design team creates eye-catching graphics, icons, and illustrations that reflect your brand’s personality. We also design effective content for websites, apps, and online stores.",
    },
    {
        id: 6,
        title: "Video Editing,  Animation & VFX",
        content: "Video is the future of digital content. We produce high-quality edits ,VFX and 2D/3D animations that are perfect for social media and digital platforms.",
    },
    {
        id: 7,
        title: "Film Production & Photography",
        content: "Our in-house team handles everything from scripts and shoots to editing and animation. We create ad films, product photos, reels and long-form videos.\nWe also produce quick-turnaround content like Instagram reels, YouTube shorts, tutorials, BTS videos, podcasts, testimonials, and product images for e-commerce.\nOur audio team creates branded music, sound effects, and audio logos.",
    },
    {
        id: 8,
        title: "Campaign Planning",
        content: "Apart from daily content, we plan and manage full campaigns and events. From idea to execution, we take care of everything to deliver memorable results.",
    },
    {
        id: 9,
        title: "Influencer Marketing & Reputation Management",
        content: "We connect brands with influencers, creators, and thought leaders to boost reach and credibility.\nOur reputation team monitors what people say about your brand online, making sure we protect and improve your image.",
    },
    {
        id: 10,
        title: "Print, Outdoor & Traditional Ads",
        content: "We’re digital-first, but we also help with offline presence. From billboards and banners to brochures, magazines, and business cards—we design assets that stand out everywhere.",
    },
    // {
    //     id: 11,
    //     title: "Brand Launch & Rebranding",
    //     content: "Our branding team helps new businesses launch and existing ones rebrand. We create everything your brand needs logos, fonts, tone of voice, style guides, and visual identity to build a strong and lasting presence.",
    // },
]

const projectSTS = [
    {
        id: 31,
        title: "",
        image: "/images/gallery/psts1.jpg",
    },
    {
        id: 32,
        title: "",
        image: "/images/gallery/psts2.jpg",
    },
]

const dropdownSTS = [
    {
        id: 1,
        title: "Custom Web Development",
        content: "We design and build responsive websites that make your brand stand out. From MTDC and TATA Communications to NIVEA and Baskin Robbins, we’ve created websites for some of the biggest names. Your site can include features like live chat, e-commerce, community tools, and location-based content.",
    }, {
        id: 2,
        title: "Web Personalization",
        content: "Every visitor is different. Using smart analytics and AI, we study their behavior and show them content that matches their needs. This makes your website more engaging, improves conversions, and brings in better leads and revenue.",
    }, {
        id: 3,
        title: "UI/UX Design",
        content: "User experience is everything. With insights from 500+ projects, we design websites and apps that are easy to use, smooth to navigate, and visually modern. We work with platforms like WordPress, Webflow, ReactJS, and more.",
    }, {
        id: 4,
        title: "Search Engine Optimization (SEO)",
        content: "We help your brand appear at the top of search results. With the right tools and strategies, we improve your online visibility so more customers can find you.",
    }, {
        id: 5,
        title: "CRM & ERP Solutions",
        content: "Our CRM systems help you track customers, send automated emails/notifications, and manage communication easily. We also create ERP dashboards to handle your daily business needs like sales, accounts, procurement, projects, and supply chain—all in one place.",
    }, {
        id: 6,
        title: "E-Commerce",
        content: "Online shopping is bigger than ever. We help you sell more with platforms like Shopify and Amazon by choosing the right channels, partners, and strategies to grow your e-business.",
    }, {
        id: 7,
        title: "Email Marketing",
        content: "Emails still work best for conversions. We design and run email campaigns that reach the right audience with the right message. From newsletters to automated funnels, we make sure your emails drive results.",
    }, {
        id: 8,
        title: "Marketing Automation",
        content: "Save time and effort with automation. We build systems that manage your communication across email, SMS, social media, and search. From generating leads to nurturing and tracking ROI, everything is handled automatically.",
    }, {
        id: 9,
        title: "Chatbots",
        content: "We create smart chatbots for your website, app, social media, and WhatsApp. They answer questions, solve problems, recommend products, and even help with sales improving customer experience and engagement 24/7.",
    },
]

const projectWSM = [
    {
        id: 21,
        title: "",
        image: "/images/gallery/pwts1.jpg",
    },
    {
        id: 22,
        title: "",
        image: "/images/gallery/pwts2.jpg",
    },
]

const dropdownWSM = [
    {
        id: 1,
        title: "WhatsApp Bulk Messages through Virtual Number",
        content: "WhatsApp bulk messaging with a virtual number helps businesses reach thousands of customers at once, without using a personal phone number.\nYou can send promotions, offers, updates, and reminders instantly.\nMessages can include text, images, videos, PDFs, links, and buttons.\nA virtual number keeps your personal number private while giving you a dedicated line for business communication.\nIt also allows automation, scheduling, and delivery tracking to see how many customers received and opened your messages.\nThis is one of the fastest ways to connect with your audience, share information, and boost customer engagement.",
    },
    {
        id: 2,
        title: "SMS Marketing",
        content: "SMS marketing is a simple yet powerful way to connect with customers. Almost everyone checks their text messages, which means higher chances of your message being seen.\nPerfect for sending alerts, offers, OTPs, appointment reminders, and event notifications.\nWorks on all types of phones—no internet required.\nQuick delivery and high open rates make SMS a reliable marketing channel.\nBulk SMS can be automated and personalized with the customer’s name, product details, or special offers.\nThis ensures your message reaches your customers directly, anytime and anywhere.",
    },
    {
        id: 3,
        title: "WhatsApp Meta Verified Marketing",
        content: "WhatsApp Meta Verified Marketing allows businesses to use official, trusted WhatsApp accounts with a green tick (Meta verification).\nBuilds trust as customers know they’re talking to a verified business.\nLets you send bulk promotional and transactional messages using WhatsApp Business API.\nYou can share catalogs, offers, and service updates in a professional and secure way.\nAllows interactive features like quick-reply buttons, CTAs (call-to-action), and payment links.\nDetailed analytics help track message delivery, open rates, and customer responses.\nWith a Meta-verified account, your business gets higher credibility, better customer engagement, and stronger brand value.",
    },
]

const counterItems = [
    { value: 5, suffix: "+", label: "Years of Experience" },
    { value: 50, suffix: "+", label: "Clients" },
    { value: 92, suffix: "+", label: "Completed Projects" },
    { value: 85, suffix: "%", label: "Client Retention Rate" },
];

const websitePortfolioData = [
    {
        "type": "website",
        "title": "Restaurant",
        "categoryDesc": "Food-first website systems designed for menus, bookings, offers, discovery, and local conversion.",
        "description": "A food-first website experience with menu discovery, booking actions, offer sections, and mobile-first conversion flows.",
        "brand": "the Copperspoon",
        "media": ["/images/web-services/gallery/p1.jpeg"],
        "mobileMedia": ["/images/web-services/gallery/p1m.jpeg"],
        "techStack": ["React", "Node.js", "Express.js", "MySQL", "PHP"],
        "visitUrl": "https://thecopperspoon.co.in/",
        "caseStudyUrl": "#",
        "accentFrom": "#00a878",
        "accentTo": "#c3f620"
    },
    {
        "type": "website",
        "title": "Beverage Company",
        "categoryDesc": "Websites for beverage brands that focus on product storytelling, campaigns, and e-commerce conversion.",
        "description": "A responsive website for a canned drinks brand with product storytelling, campaign pages, and e-commerce conversion.",
        "brand": "Fizzi",
        "media": ["/images/web-services/gallery/p2.jpeg"],
        "mobileMedia": ["/images/web-services/gallery/p2m.jpeg"],
        "techStack": ["Nextjs", "Node.js", "Express.js", "GSAP"],
        "visitUrl": "https://fizzi-demo.vercel.app/",
        "caseStudyUrl": "#",
        "accentFrom": "#62e6c8",
        "accentTo": "#c3f620"
    },
    {
        "type": "website",
        "title": "Real Estate",
        "categoryDesc": "Responsive web experiences for property brands, project launches, lead capture, and premium location storytelling.",
        "description": "A responsive property website with project highlights, lead capture, location storytelling, and premium visual presentation.",
        "brand": "ya design studios",
        "media": ["/images/web-services/gallery/p4.jpeg"],
        "mobileMedia": ["/images/web-services/gallery/p4m.jpeg"],
        "techStack": ["React", "Node.js", "Express.js", "PostgreSQL", "Stripe"],
        "visitUrl": "https://yadesignstudios.com/",
        "caseStudyUrl": "#",
        "accentFrom": "#c3f620",
        "accentTo": "#00a878"
    },
    {
        "type": "website",
        "title": "Fashion Ecommerce",
        "categoryDesc": "Fast storefront experiences for product storytelling, collection drops, campaigns, and checkout conversion.",
        "description": "A fast ecommerce storefront built for product storytelling, launch drops, collection pages, and checkout conversion.",
        "brand": "kessa",
        "media": ["/images/web-services/gallery/p3.jpeg"],
        "mobileMedia": ["/images/web-services/gallery/p3m.jpeg"],
        "techStack": ["WordPress", "Elementor", "WooCommerce"],
        "visitUrl": "https://www.kessa.com/",
        "caseStudyUrl": "#",
        "accentFrom": "#62e6c8",
        "accentTo": "#c3f620"
    },
    {
        "type": "website",
        "title": "Husbandry",
        "categoryDesc": "Responsive web experiences for husbandry brands with product storytelling, campaign pages, and e-commerce conversion.",
        "description": "A responsive website for a husbandry brand with product storytelling, campaign pages, and e-commerce conversion.",
        "brand": "doodh vriddhi",
        "media": ["/images/web-services/gallery/p5.jpeg"],
        "mobileMedia": ["/images/web-services/gallery/p5m.jpeg"],
        "techStack": ["WordPress", "Elementor", "WooCommerce"],
        "visitUrl": "https://doodhvriddhi.com/",
        "caseStudyUrl": "#",
        "accentFrom": "#62e6c8",
        "accentTo": "#c3f620"
    },
    //
    {
        "type": "website",
        "title": "Interior Design",
        "categoryDesc": "Editorial portfolio websites for design studios that need to showcase spaces, process, and inquiry journeys.",
        "description": "An editorial portfolio website for showcasing spaces, design process, testimonials, and high-intent inquiry journeys.",
        "brand": "Studio Haus",
        "media": ["/images/web-services/gallery/interior.jpg"],
        "mobileMedia": ["/images/web-services/gallery/interior.jpg"],
        "techStack": ["React", "Gallery", "CRM"],
        "visitUrl": "#",
        "caseStudyUrl": "#",
        "accentFrom": "#35d0ab",
        "accentTo": "#c3f620"
    },
    {
        "type": "website",
        "title": "Travel",
        "categoryDesc": "Travel websites built around route discovery, destination content, campaign pages, and booking-friendly navigation.",
        "description": "A travel brand website with route information, search-led content, campaign pages, and booking-friendly navigation.",
        "brand": "Route Mate",
        "media": ["/images/web-services/gallery/travel.jpg"],
        "mobileMedia": ["/images/web-services/gallery/travel.jpg"],
        "techStack": ["Vite", "Maps", "SEO"],
        "visitUrl": "#",
        "caseStudyUrl": "#",
        "accentFrom": "#00a878",
        "accentTo": "#62e6c8"
    },
    {
        "type": "website",
        "title": "Fashion Ecommerce",
        "categoryDesc": "Fast storefront experiences for product storytelling, collection drops, campaigns, and checkout conversion.",
        "description": "A fast ecommerce storefront built for product storytelling, launch drops, collection pages, and checkout conversion.",
        "brand": "Mode Market",
        "media": ["/images/web-services/gallery/fashion.jpg"],
        "mobileMedia": ["/images/web-services/gallery/fashion.jpg"],
        "techStack": ["Shopify", "UI/UX", "CRO"],
        "visitUrl": "#",
        "caseStudyUrl": "#",
        "accentFrom": "#c3f620",
        "accentTo": "#00a878"
    },
];

const b2bCompanies = [
    {
        icon: "/images/b2bLogos/b2bL1.webp",
        title: "DigitalOps",
        description:
            "DigitalOps is a performance-driven digital marketing agency that helps businesses grow their online presence using AI-powered strategies. The company offers services such as SEO, paid advertising, social media marketing, and web development to generate leads and improve revenue growth for brands.",
        tags: [
            "SEO (Search Engine Optimization)",
            "PPC / Google Ads",
            "Social Media Marketing",
        ],
        location: "Hyderabad, Telangana, India",
    },
    {
        icon: "/images/b2bLogos/b2bL2.webp",
        title: "Digital Spider",
        description:
            "Digital Spider is a digital marketing agency that provides customized online marketing and web solutions for businesses of all sizes. Their team focuses on improving brand visibility and generating leads through digital marketing strategies, website development, and online advertising.",
        tags: [
            "Website Development",
            "Digital Marketing",
            "Google & Social Media Ads",
        ],
        location: "Bangalore, Karnataka, India",
    },
    {
        icon: "/images/b2bLogos/b2bL3.webp",
        title: "KGS Marketing (Keep Going Social)",
        description:
            "KGS Marketing is a marketing and branding agency that helps businesses build and scale their brand presence both online and offline. The company works with social media managers, content creators, designers, and marketing experts to create campaigns that improve engagement and brand visibility.",
        tags: [
            "Social Media Marketing",
            "Influencer Marketing",
            "Content Marketing",
        ],
        location: "Goa, India (Margao / Mapusa area)",
    },
    {
        icon: "/images/b2bLogos/b2bL4.webp",
        title: "Frick",
        description:
            "Frick is a marketing and mar-tech company that focuses on brand growth and digital marketing solutions. The agency works on brand storytelling, growth-hacking strategies, and marketing technology solutions to help businesses improve their brand presence and performance.",
        tags: [
            "Brand Strategy",
            "Growth Marketing",
            "Marketing Technology (MarTech)",
        ],
        location: "Mumbai, Maharashtra, India",
    },
    {
        icon: "/images/b2bLogos/b2bL5.webp",
        title: "Grandeur Net",
        description:
            "Grandeur Net is a digital marketing and IT services company that helps startups, small businesses, and enterprises grow their online presence. The company offers digital marketing, web development, app development, and branding solutions to support business growth across various industries.",
        tags: ["SEO Services", "Website Development", "Social Media Marketing"],
        location: "Dehradun, Uttarakhand, India",
    },
    {
        icon: "/images/b2bLogos/b2bL6.webp",
        title: "Blazontek",
        description:
            "Blazontek is a full-service internet marketing and technology company offering digital marketing and SEO solutions. The company focuses on helping businesses improve online visibility and achieve better results through performance-driven digital strategies and search engine optimization services.",
        tags: [
            "Digital Marketing",
            "Search Engine Optimization (SEO)",
            "Internet Marketing",
        ],
        location: "India",
    },
];

const portfolioData = [
    {
        "type": "image",
        "title": "Bus Operators",
        "categoryDesc": "Travel and transport creatives built to highlight routes, comfort, offers, and booking confidence for bus operators.",
        "description": "High-impact travel creatives focused on comfort, routes, and seamless booking experience.",
        "brand": "Snr Paribahan",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/1.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/2.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/4.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/8.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/9.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/10.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/12.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/13.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/14.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/15.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/16.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/27.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/28.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/30.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/31.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/snrParibahan/33.webp"
        ]
    },
    {
        "type": "image",
        "title": "Bus Operators",
        "categoryDesc": "Travel and transport creatives built to highlight routes, comfort, offers, and booking confidence for bus operators.",
        "description": "Modern travel creatives designed to highlight convenience, comfort, and customer satisfaction.",
        "brand": "Luxeliner",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/busoperator/luxeliner/1.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/luxeliner/2.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/luxeliner/3.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/luxeliner/4.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/luxeliner/5.webp",
        ]
    },
    {
        "type": "image",
        "title": "Bus Operators",
        "categoryDesc": "Travel and transport creatives built to highlight routes, comfort, offers, and booking confidence for bus operators.",
        "description": "Modern travel creatives designed to highlight convenience, comfort, and customer satisfaction.",
        "brand": "Khamsa Travels",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/busoperator/khamsaTravels/1.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/khamsaTravels/2.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/khamsaTravels/3.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/khamsaTravels/4.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/khamsaTravels/5.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/khamsaTravels/6.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/khamsaTravels/7.webp",
        ]
    },
    {
        "type": "image",
        "title": "Bus Operators",
        "categoryDesc": "Travel and transport creatives built to highlight routes, comfort, offers, and booking confidence for bus operators.",
        "description": "Bold transport creatives focused on regional connectivity, affordability, and travel efficiency.",
        "brand": "Gujarat Travels",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/busoperator/gujaratTravels/17.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/gujaratTravels/18.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/gujaratTravels/19.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/gujaratTravels/20.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/gujaratTravels/23.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/gujaratTravels/24.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/gujaratTravels/25.webp",
            "https://adszie.in/portfoliouploads/creatives/busoperator/gujaratTravels/35.webp"
        ]
    },
    {
        "type": "image",
        "title": "Bus Operators",
        "categoryDesc": "Travel and transport creatives built to highlight routes, comfort, offers, and booking confidence for bus operators.",
        "description": "Clean, informative creatives emphasizing network reach, punctuality, and smooth travel services.",
        "brand": "Network Travels",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/busoperator/networkTravels/21.webp"
        ]
    },
    {
        "type": "image",
        "title": "Bus Operators",
        "categoryDesc": "Travel and transport creatives built to highlight routes, comfort, offers, and booking confidence for bus operators.",
        "description": "Premium-style creatives reflecting luxury travel experience, comfort, and reliable service offerings.",
        "brand": "Deltin Travels",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/busoperator/deltinTravels/22.webp"
        ]
    },
    {
        "type": "image",
        "title": "Bus Operators",
        "categoryDesc": "Travel and transport creatives built to highlight routes, comfort, offers, and booking confidence for bus operators.",
        "description": "High-impact travel creatives focused on comfort, routes, and seamless booking experience.",
        "brand": "Patel Tours and Travels",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/busoperator/patelToursAndTravels/26.webp"
        ]
    },
    {
        "type": "image",
        "title": "Automotive Industry",
        "categoryDesc": "Creative designs built for impactful automotive brand marketing.",
        "description": "Performance-driven creatives highlighting car servicing, repairs, and professional garage expertise.",
        "brand": "KTM",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/automotive/ktm/1.webp"
        ]
    },
    {
        "type": "image",
        "title": "Automotive Industry",
        "categoryDesc": "Creative designs built for impactful automotive brand marketing.",
        "description": "Visually engaging designs focused on automotive care, maintenance, and customer trust building.",
        "brand": "Multi-Brand Projects",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/automotive/multiBrand/2.webp"
        ]
    },
    {
        "type": "image",
        "title": "Jewellery",
        "categoryDesc": "Premium jewellery creatives designed to showcase craftsmanship, elegance, festive demand, and purchase desire.",
        "description": "Elegant jewellery creatives highlighting craftsmanship, tradition, and premium gold collections.",
        "brand": "Senco Gold & Diamonds",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/jewellery/sencoGold/1.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/sencoGold/2.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/sencoGold/4.webp"
        ]
    },
    {
        "type": "image",
        "title": "Jewellery",
        "categoryDesc": "Premium jewellery creatives designed to showcase craftsmanship, elegance, festive demand, and purchase desire.",
        "description": "Luxury-focused creatives showcasing fine jewellery, sparkle, and timeless design appeal.",
        "brand": "Kavitha Gold & Diamonds",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/1.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/2.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/3.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/4.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/5.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/6.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/7.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/8.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/9.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/10.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/11.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/12.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/13.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/14.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/kavitha/15.webp",
        ]
    },
    {
        "type": "image",
        "title": "Jewellery",
        "categoryDesc": "Premium jewellery creatives designed to showcase craftsmanship, elegance, festive demand, and purchase desire.",
        "description": "Modern jewellery creatives targeting contemporary style, elegance, and everyday luxury wear.",
        "brand": "Yuvora Jewels",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/jewellery/yuvoraJewels/3.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/yuvoraJewels/8.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/yuvoraJewels/9.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/yuvoraJewels/5.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/yuvoraJewels/6.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/yuvoraJewels/7.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/yuvoraJewels/10.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/yuvoraJewels/11.webp",
            "https://adszie.in/portfoliouploads/creatives/jewellery/yuvoraJewels/12.webp"
        ]
    },
    {
        "type": "image",
        "title": "Cosmetic Products",
        "categoryDesc": "Beauty and skincare creatives shaped around product benefits, natural appeal, and visual shelf impact.",
        "description": "Natural-inspired creatives emphasizing herbal ingredients, skincare wellness, and brand trust.",
        "brand": "Lotus Herbals",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/cosmetics/lotusHerbals/1.webp"
        ]
    },
    {
        "type": "image",
        "title": "Cosmetic Products",
        "categoryDesc": "Beauty and skincare creatives shaped around product benefits, natural appeal, and visual shelf impact.",
        "description": "Aesthetic beauty creatives highlighting skincare benefits, glow enhancement, and product appeal.",
        "brand": "Violet Glow",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/cosmetics/violetGlow/2.webp"
        ]
    },
    {
        "type": "image",
        "title": "Electronics",
        "categoryDesc": "Technology creatives made to communicate product value, lifestyle fit, and modern feature-led appeal.",
        "description": "Dynamic product creatives focused on sound quality, lifestyle appeal, and modern tech aesthetics.",
        "brand": "Noise",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/electronics/noise/1.webp"
        ]
    },
    {
        "type": "image",
        "title": "Festive Seasons",
        "categoryDesc": "Seasonal campaign creatives crafted for offers, celebrations, timely engagement, and high recall.",
        "description": "Scroll-stopping festive creatives crafted to boost visibility, engagement, and campaign performance.",
        "brand": "Multi-Brand Festive Designs",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/festive/multiBrand/1.webp",
            "https://adszie.in/portfoliouploads/creatives/festive/multiBrand/2.webp"
        ]
    },
    {
        "type": "image",
        "title": "Logistics",
        "categoryDesc": "Logistics creatives focused on reliability, delivery strength, network reach, and operational trust.",
        "description": "Corporate-style creatives focused on reliability, logistics excellence, and supply chain strength.",
        "brand": "Safexpress",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/logistics/safexpress/2.webp",
            "https://adszie.in/portfoliouploads/creatives/logistics/safexpress/3.webp",
            "https://adszie.in/portfoliouploads/creatives/logistics/safexpress/4.webp",
            "https://adszie.in/portfoliouploads/creatives/logistics/safexpress/5.webp"
        ]
    },
    {
        "type": "image",
        "title": "Logistics",
        "categoryDesc": "Logistics creatives focused on reliability, delivery strength, network reach, and operational trust.",
        "description": "Strong logistics creatives emphasizing speed, safety, and nationwide delivery capabilities.",
        "brand": "Gujarat Cargo",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/logistics/gujaratCargo/6.webp",
            "https://adszie.in/portfoliouploads/creatives/logistics/gujaratCargo/7.webp",
        ]
    },
    {
        "type": "image",
        "title": "Logistics",
        "categoryDesc": "Logistics creatives focused on reliability, delivery strength, network reach, and operational trust.",
        "description": "Corporate-style creatives focused on reliability, logistics excellence, and supply chain strength.",
        "brand": "Blue Dart",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/logistics/blueDart/8.webp"
        ]
    },
    {
        "type": "image",
        "title": "Logistics",
        "categoryDesc": "Logistics creatives focused on reliability, delivery strength, network reach, and operational trust.",
        "description": "Corporate-style creatives focused on reliability, logistics excellence, and supply chain strength.",
        "brand": "Multi-Brand Designs",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/logistics/multiBrand/1.webp",
        ]
    },
    {
        "type": "image",
        "title": "Shoe",
        "categoryDesc": "Footwear creatives built around performance, style, comfort, and everyday product desirability.",
        "description": "Footwear creatives built around performance, style, comfort, and everyday product desirability.",
        "brand": "Multi-Brand Shoe Designs",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/shoe/multiBrand/4.webp",
        ]
    },
    {
        "type": "image",
        "title": "Shoe",
        "categoryDesc": "Footwear creatives built around performance, style, comfort, and everyday product desirability.",
        "description": "High-energy creatives reflecting performance, innovation, and global sports lifestyle branding.",
        "brand": "Nike",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/shoe/nike/2.webp",
            "https://adszie.in/portfoliouploads/creatives/shoe/nike/3.webp",
            "https://adszie.in/portfoliouploads/creatives/shoe/nike/6.webp"
        ]
    },
    {
        "type": "image",
        "title": "Shoe",
        "categoryDesc": "Footwear creatives built around performance, style, comfort, and everyday product desirability.",
        "description": "Stylish footwear creatives highlighting comfort, durability, and modern fashion appeal.",
        "brand": "Redtape",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/shoe/redtape/5.webp"
        ]
    },
    {
        "type": "image",
        "title": "Shoe",
        "categoryDesc": "Footwear creatives built around performance, style, comfort, and everyday product desirability.",
        "description": "Stylish footwear creatives highlighting comfort, durability, and modern fashion appeal.",
        "brand": "Ajanta Shoes",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/shoe/ajanta/1.webp"
        ]
    },
    {
        "type": "image",
        "title": "Real Estate",
        "categoryDesc": "Real estate creatives designed to present properties, locations, lifestyle value, and investment confidence.",
        "description": "High-conversion creatives showcasing premium properties, lifestyle living, and investment value.",
        "brand": "Merlin",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/realestate/merlin/1.webp"
        ]
    },
    {
        "type": "image",
        "title": "Food & Beverage",
        "categoryDesc": "Food and beverage creatives made to drive appetite, brand recall, offers, and product-led engagement.",
        "description": "Food and beverage creatives made to drive appetite, brand recall, offers, and product-led engagement.",
        "brand": "Burger King",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/foodindustry/burgerKing/1.webp",
            "https://adszie.in/portfoliouploads/creatives/foodindustry/burgerKing/2.webp",
            "https://adszie.in/portfoliouploads/creatives/foodindustry/burgerKing/3.webp"
        ]
    },
    {
        "type": "image",
        "title": "Food & Beverage",
        "categoryDesc": "Food and beverage creatives made to drive appetite, brand recall, offers, and product-led engagement.",
        "description": "Food and beverage creatives made to drive appetite, brand recall, offers, and product-led engagement.",
        "brand": "Budweiser",
        "media": [
            "https://adszie.in/portfoliouploads/creatives/foodindustry/budweiser/4.webp"
        ]
    },
    {
        "type": "video",
        "title": "Car Garages",
        "categoryDesc": "Short-form automotive videos capturing service processes, transformations, and garage expertise.",
        "description": "Showcasing Automotive Expertise. Capturing the precision, craftsmanship, and transformation behind every service.",
        "brand": "Rocky’s Car Garage, Bangalore",
        "media": [
            "https://adszie.in/portfoliouploads/reels/cargarage/rockysCarGarageBangalore/v1.mp4",
            "https://adszie.in/portfoliouploads/reels/cargarage/rockysCarGarageBangalore/v2.mp4",
            "https://adszie.in/portfoliouploads/reels/cargarage/rockysCarGarageBangalore/v3.mp4",
            "https://adszie.in/portfoliouploads/reels/cargarage/rockysCarGarageBangalore/v4.mp4",
            "https://adszie.in/portfoliouploads/reels/cargarage/rockysCarGarageBangalore/v5.mp4",
            "https://adszie.in/portfoliouploads/reels/cargarage/rockysCarGarageBangalore/v6.mp4",
            "https://adszie.in/portfoliouploads/reels/cargarage/rockysCarGarageBangalore/v7.mp4",
            "https://adszie.in/portfoliouploads/reels/cargarage/rockysCarGarageBangalore/v8.mp4",
            "https://adszie.in/portfoliouploads/reels/cargarage/rockysCarGarageBangalore/v9.mp4",
            "https://adszie.in/portfoliouploads/reels/cargarage/rockysCarGarageBangalore/v10.mp4",
        ]
    },
    {
        "type": "video",
        "title": "Jewellery",
        "categoryDesc": "Premium jewellery videos created to highlight detail, shine, emotion, and product storytelling.",
        "description": "Adszie handled scripting, shoot, and editing to create a premium video that captures the intricacy, shine, and emotional value of each piece.",
        "brand": "Senco Gold & Diamonds",
        "media": [
            "https://adszie.in/portfoliouploads/reels/jewellery/sencoGoldAndDiamonds/v1.mp4",
            "https://adszie.in/portfoliouploads/reels/jewellery/sencoGoldAndDiamonds/v2.mp4"
        ]
    },
    {
        "type": "video",
        "title": "B2B Projects",
        "categoryDesc": "B2B service videos designed to explain offerings, showcase expertise, and build brand trust among business audiences.",
        "description": "Team Adszie created videos for SocialBar. High-quality editing, we delivered engaging videos that highlight their expertise in managing social media presence for businesses.",
        "brand": "SocialBar",
        "media": [
            "https://adszie.in/portfoliouploads/reels/b2b/socialBar/v8.mp4",
            "https://adszie.in/portfoliouploads/reels/b2b/socialBar/v7.mp4",
            "https://adszie.in/portfoliouploads/reels/b2b/socialBar/v1.mp4",
            "https://adszie.in/portfoliouploads/reels/b2b/socialBar/v2.mp4",
            "https://adszie.in/portfoliouploads/reels/b2b/socialBar/v3.mp4",
            "https://adszie.in/portfoliouploads/reels/b2b/socialBar/v4.mp4",
            "https://adszie.in/portfoliouploads/reels/b2b/socialBar/v5.mp4",
            "https://adszie.in/portfoliouploads/reels/b2b/socialBar/v6.mp4",
        ]
    },
    {
        "type": "video",
        "title": "B2B Projects",
        "categoryDesc": "B2B service videos designed to explain offerings, showcase expertise, and build brand trust among business audiences.",
        "description": "Adszie created videos for Adclickr. High-quality editing, we delivered engaging videos that highlight their expertise in managing social media presence for businesses.",
        "brand": "Adclickr",
        "media": [
            "https://adszie.in/portfoliouploads/reels/b2b/adClickr/v2.mp4",
            "https://adszie.in/portfoliouploads/reels/b2b/adClickr/v1.mp4",
        ]
    },
    {
        "type": "video",
        "title": "Podcast Capture",
        "categoryDesc": "Podcast content edited for clarity, pacing, audience retention, and polished social distribution.",
        "description": "We handled the editing process, transforming raw podcast footage into engaging, audience-friendly content with smooth flow, clarity, and strong visual appeal.",
        "brand": "Veena Murthy – Personal Growth Coach",
        "media": [
            "https://adszie.in/portfoliouploads/reels/podcast/veenaMurthyPersonalGrowthCoach/v1.mp4"
        ]
    },
    {
        "type": "video",
        "title": "Bus Operators",
        "categoryDesc": "Travel videos built to showcase fleet quality, routes, journeys, and on-ground brand presence.",
        "description": "from scripting and on-ground shoot to high-quality editing, creating a video that highlights their fleet. We handled all.",
        "brand": "SNR Paribahan",
        "media": [
            "https://adszie.in/portfoliouploads/reels/busoperator/snrParibahan/v1.mp4",
            "https://adszie.in/portfoliouploads/reels/busoperator/snrParibahan/v2.mp4",
            "https://adszie.in/portfoliouploads/reels/busoperator/snrParibahan/v3.mp4",
            "https://adszie.in/portfoliouploads/reels/busoperator/snrParibahan/v4.mp4",
            "https://adszie.in/portfoliouploads/reels/busoperator/snrParibahan/v5.mp4",
            "https://adszie.in/portfoliouploads/reels/busoperator/snrParibahan/v6.mp4",
            "https://adszie.in/portfoliouploads/reels/busoperator/snrParibahan/v7.mp4",
            "https://adszie.in/portfoliouploads/reels/busoperator/snrParibahan/v8.mp4",
            "https://adszie.in/portfoliouploads/reels/busoperator/snrParibahan/v10.mp4",
            "https://adszie.in/portfoliouploads/reels/busoperator/snrParibahan/v11.mp4",
        ]
    },
    {
        "type": "video",
        "title": "Interior Designers",
        "categoryDesc": "Interior design videos focused on spaces, execution quality, visual storytelling, and project detail.",
        "description": "producing a visually rich video that reflects their design philosophy and execution quality.",
        "brand": "Nexspace Interiors",
        "media": [
            "https://adszie.in/portfoliouploads/reels/interiordesigner/nexspaceInteriors/v1.mp4",
            "https://adszie.in/portfoliouploads/reels/interiordesigner/nexspaceInteriors/v2.mp4",
            "https://adszie.in/portfoliouploads/reels/interiordesigner/nexspaceInteriors/v3.mp4",
            "https://adszie.in/portfoliouploads/reels/interiordesigner/nexspaceInteriors/v4.mp4",
            "https://adszie.in/portfoliouploads/reels/interiordesigner/nexspaceInteriors/v7.mp4",
            "https://adszie.in/portfoliouploads/reels/interiordesigner/nexspaceInteriors/v8.mp4",
        ]
    },
    {
        "type": "video",
        "title": "Interior Designers",
        "categoryDesc": "Interior design videos focused on spaces, execution quality, visual storytelling, and project detail.",
        "description": "Adszie focused on post-production, delivering clean, elegant edits that enhance the visual storytelling of their projects and highlight design details.",
        "brand": "Sarkars Interior Studio",
        "media": [
            "https://adszie.in/portfoliouploads/reels/interiordesigner/sarkarsInteriorStudio/v5.mp4",
            "https://adszie.in/portfoliouploads/reels/interiordesigner/sarkarsInteriorStudio/v6.mp4",

        ]
    },
    {
        "type": "video",
        "title": "Academy",
        "categoryDesc": "Educational brand videos designed to explain product value, philosophy, and learning-led engagement.",
        "description": "Adszie crafted a compelling educational video designed to communicate their philosophy and product value through engaging storytelling, clean visuals, and refined post-production.",
        "brand": "Amulya Herbs",
        "media": [
            "https://adszie.in/portfoliouploads/reels/academy/amulyaHerbs/v1.mp4"
        ]
    },
    {
        "type": "video",
        "title": "Content Creator",
        "categoryDesc": "Content creator videos made to highlight personal brand, content style, and audience connection.",
        "description": "Adszie collaborated with @anjalichothani to create engaging content that showcases their expertise and unique style.",
        "brand": "@anjalichothani",
        "media": [
            "https://adszie.in/portfoliouploads/reels/contentCreator/anjaliChothani/v1.mp4"
        ]
    },
    {
        "type": "video",
        "title": "Real Estate",
        "categoryDesc": "Property videos made to showcase spaces, locations, lifestyle value, and real estate conversion cues.",
        "description": "Adszie executed scripting, shoot, and editing to create a compelling property showcase video that highlights space, value, and location benefits.",
        "brand": "SS Property",
        "media": [
            "https://adszie.in/portfoliouploads/reels/realestate/ssProperty/v2.mp4",
            "https://adszie.in/portfoliouploads/reels/realestate/ssProperty/v3.mp4"
        ]
    },
    {
        "type": "video",
        "title": "Real Estate",
        "categoryDesc": "Property videos made to showcase spaces, locations, lifestyle value, and real estate conversion cues.",
        "description": "Adszie developed AI-driven video content — combining strategic scripting with advanced editing — to create visually engaging and scalable promotional videos.",
        "brand": "Bricklane Realty (AI Video Content)",
        "media": [
            "https://adszie.in/portfoliouploads/reels/realestate/bricklaneRealty/v4.mp4"
        ]
    },
    {
        "type": "video",
        "title": "Real Estate",
        "categoryDesc": "Property videos made to showcase spaces, locations, lifestyle value, and real estate conversion cues.",
        "description": "Adszie handled the editing process, creating a visually engaging video that highlights the unique features and lifestyle appeal of their properties.",
        "brand": "International Real Estate Professional",
        "media": [
            "https://adszie.in/portfoliouploads/reels/realestate/internationalRealEstateProfessional/v1.mp4"
        ]
    },
    {
        "type": "video",
        "title": "Restaurant",
        "categoryDesc": "Restaurant videos created to capture food, ambiance, service moments, and dining appeal.",
        "description": "We handled shoot and editing, capturing the essence of their dishes, ambiance, and dining experience through visually appetizing storytelling.",
        "brand": "Kitchen Story",
        "media": [
            "https://adszie.in/portfoliouploads/reels/restaurant/kitchenStory/v1.mp4",
            "https://adszie.in/portfoliouploads/reels/restaurant/kitchenStory/v2.mp4"
        ]
    },
    {
        "type": "video",
        "title": "Trading & Finance",
        "categoryDesc": "Educational trading videos edited for credibility, clarity, and short-form learning engagement.",
        "description": "Adszie handled the editing process, transforming educational content into engaging, easy-to-understand videos that build credibility and audience trust.",
        "brand": "Metaverse Trading Academy",
        "media": [
            "https://adszie.in/portfoliouploads/reels/stockmarket/metaverseTradingAcademy/v1.mp4"
        ]
    }
];

export {
    logo,
    logoB,
    words,
    navitems,
    imageLogos,
    socialLinks,
    contactInfo,
    casestudy,
    verticalCards,
    projectBGS,
    dropdownBGS,
    projectSTS,
    dropdownSTS,
    projectWSM,
    dropdownWSM,
    caseStudyModal,
    counterItems,
    websitePortfolioData,
    b2bCompanies,
    portfolioData,
};
